import script from "./BookingWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingWidget.vue?vue&type=script&setup=true&lang=js"

import "./BookingWidget.vue?vue&type=style&index=0&id=d8347958&scoped=true&lang=scss"
import "./BookingWidget.vue?vue&type=style&index=1&id=d8347958&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8347958"]])

export default __exports__